<template>
  <div class="hzc-industry-dynamics">
    <div class="back">当前位置：<span style="cursor: pointer" @click="back('/coal')">焦煤</span> > <span
        @click="back(url)" style="cursor: pointer">{{title}}</span> > 正文
    </div>
    <div class="content">
      <div class="top">
        <p>{{ row.titleName }}</p>
        <span>发布时间：{{ row.showYearTime }}</span><span>来源：{{ row.updateBy || "网络" }}</span>
      </div>
      <div class="bom" v-html="row.newsContent"></div>
    </div>
  </div>
</template>

<script>
import {
  industryDetail,
} from '@/api/coal'

export default {
  data() {
    return {
      row: {},
      page: 1,
      size: 15,
      total: 0,
      url: "",
      title:"",
      flag:""
    }
  },
  created() {
    this.getIndustry(this.$route.query.id);
    if(this.$route.query.flag == 5 ) {
      this.title = '煤炭快讯'
      this.url = '/coal/twoPage/industry?flag=5'
      this.flag = 5
    } else {
      this.title= '行业要闻'
      this.url = '/coal/twoPage/industry?flag=4'
      this.flag = 4
    }
  },
  methods: {
    // 行业动态
    getIndustry(pageParams) {
      industryDetail(pageParams).then(res => {
        this.row = res.data;
        // console.log(this.row)
        this.time = this.row.createTime
        this.time = (this.time ).split(/[ ]+/);
        // console.log(this.time)
      })
    },
    back(url) {
      this.$router.push(url);
      // console.log(this.flag)
    },
  }
}
</script>

<style scoped lang="less">
.hzc-industry-dynamics {
  width: 1200px;
  margin: 0 auto;

  .content {
    width: 960px;
    min-height: 500px;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    margin:16px auto 0;

    .top {

      border-bottom: 1px solid #ccc;
      padding: 16px 0;
      text-align: center;

      p {
        color: #222;
        font-size: 24px;
      }
      span {
        display: inline-block;
        margin-right: 16px;
        color: #777777;
        font-size: 12px;
      }
    }
    .bom {
      padding:16px 40px;
      ::v-deep {
        img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
